import { adminsActions } from '../ActionTypes';
import { updateState } from '../../middlewares/utils';

const initialFormData = {
  Id: '0',
  AdminName: '',
  MobileNumber: '',
  IsActive: '',
  EmailId: '',
  LoginId: '',
  Password: ''
};

const defaultState = {
  adminsList: [],
  tableLoading: false,
  form: initialFormData,
  formLoading: false,
  formError: null,
  deleteId: null
};


export default (state = defaultState, actions) => {
  switch (actions.type) {
    case adminsActions.ADMINS_FETCH_START:
      return updateState(state, { tableLoading: true });
    case adminsActions.ADMINS_FETCH_SUCCESS:
      return updateState(state, { tableLoading: false, adminsList: actions.payload });
    case adminsActions.ADMINS_FETCH_ERROR:
      return updateState(state, { tableLoading: false, ...actions.payload });
    case adminsActions.ADMINS_SAVE_START:
      return updateState(state, { formLoading: true, formError: null, form: initialFormData });
    case adminsActions.ADMINS_SAVE_SUCCESS:
      return updateState(state, { formLoading: false, form: initialFormData });
    case adminsActions.ADMINS_SAVE_FAILED:
      return updateState(state, { formLoading: false, ...actions.payload });
    case adminsActions.ADMINS_SET_FORM:
      return updateState(state, { ...actions.payload, formError: null });
    case adminsActions.ADMINS_RESET_FORM:
      return updateState(state, { form: initialFormData });
    default:
      return state;
  }
};
